var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 62,
    viewBox: "0 0 192 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 190,
    height: 61,
    rx: 3.5,
    fill: "#111111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1252 14.3171C19.7292 14.719 19.5 15.3446 19.5 16.1549V45.0564C19.5 45.8667 19.7292 46.4923 20.1252 46.8942L20.2229 46.9824L36.9293 30.7935V30.4113L20.2229 14.2224L20.1252 14.3171Z",
    fill: "url(#paint0_linear_1265_12979)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4923 36.1924L36.9297 30.7934V30.4111L42.499 25.0121L42.6237 25.0823L49.2194 28.7203C51.1016 29.7528 51.1016 31.4517 49.2194 32.4907L42.6237 36.1221L42.4923 36.1924Z",
    fill: "url(#paint1_linear_1265_12979)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6232 36.1223L36.9291 30.6024L20.125 46.8942C20.7502 47.5313 21.7697 47.608 22.9291 46.9709L42.6232 36.1223Z",
    fill: "url(#paint2_linear_1265_12979)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6232 25.0831L22.9291 14.2344C21.7697 13.6039 20.7502 13.6806 20.125 14.3177L36.9291 30.603L42.6232 25.0831Z",
    fill: "url(#paint3_linear_1265_12979)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8638 17.8526C66.8638 18.9438 66.5267 19.8178 65.8628 20.4696C65.0994 21.2423 64.1052 21.6311 62.8869 21.6311C61.7224 21.6311 60.7282 21.2358 59.9126 20.4566C59.0953 19.6659 58.6875 18.6955 58.6875 17.5341C58.6875 16.3726 59.0953 15.4022 59.9126 14.6181C60.7282 13.8323 61.7224 13.437 62.8869 13.437C63.4665 13.437 64.0193 13.553 64.5467 13.7686C65.0725 13.9859 65.5005 14.2799 65.8106 14.6426L65.1062 15.332C64.5652 14.7128 63.8288 14.4074 62.8869 14.4074C62.0375 14.4074 61.3011 14.6949 60.676 15.2748C60.0575 15.8564 59.7474 16.6094 59.7474 17.5341C59.7474 18.4587 60.0575 19.2183 60.676 19.7998C61.3011 20.3732 62.0375 20.6673 62.8869 20.6673C63.7884 20.6673 64.5467 20.3732 65.1449 19.7933C65.5392 19.4094 65.7634 18.8801 65.8224 18.2038H62.8869V17.2596H66.8031C66.8503 17.4638 66.8638 17.6615 66.8638 17.8526Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.103259,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0775 14.5794H69.3988V17.0624H72.7152V18.0066H69.3988V20.4897H73.0775V21.4519H68.3574V13.6172H73.0775V14.5794Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.103259,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4619 21.4519H76.4205V14.5794H74.1641V13.6172H79.7199V14.5794H77.4619V21.4519Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.103259,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7402 21.4519V13.6172H84.78V21.4519H83.7402Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.103259,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3896 21.4519H88.3566V14.5794H86.0918V13.6172H91.6544V14.5794H89.3896V21.4519Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.103259,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.172 20.4435C101.375 21.2358 100.387 21.6311 99.2094 21.6311C98.0248 21.6311 97.0373 21.2358 96.2402 20.4435C95.4448 19.6528 95.0488 18.6825 95.0488 17.5341C95.0488 16.3856 95.4448 15.4153 96.2402 14.6246C97.0373 13.8323 98.0248 13.437 99.2094 13.437C100.381 13.437 101.368 13.8323 102.165 14.6312C102.967 15.4284 103.363 16.3922 103.363 17.5341C103.363 18.6825 102.967 19.6528 102.172 20.4435ZM97.0103 19.7868C97.6102 20.3732 98.3399 20.6673 99.2094 20.6673C100.072 20.6673 100.809 20.3732 101.402 19.7868C102 19.2003 102.303 18.4472 102.303 17.5341C102.303 16.6209 102 15.8678 101.402 15.2813C100.809 14.6949 100.072 14.4008 99.2094 14.4008C98.3399 14.4008 97.6102 14.6949 97.0103 15.2813C96.4121 15.8678 96.1088 16.6209 96.1088 17.5341C96.1088 18.4472 96.4121 19.2003 97.0103 19.7868Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.103259,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.824 21.4519V13.6172H106.088L110.018 19.7105H110.063L110.018 18.2043V13.6172H111.058V21.4519H109.972L105.857 15.058H105.812L105.857 16.5707V21.4519H104.824Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.103259,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7925 32.8928C91.6262 32.8928 89.0395 35.2288 89.0395 38.4519C89.0395 41.6488 91.6262 44.0094 94.7925 44.0094C97.9656 44.0094 100.552 41.6488 100.552 38.4519C100.552 35.2288 97.9656 32.8928 94.7925 32.8928ZM94.7925 41.8204C93.0552 41.8204 91.5605 40.4302 91.5605 38.4519C91.5605 36.4475 93.0552 35.0818 94.7925 35.0818C96.5299 35.0818 98.0314 36.4475 98.0314 38.4519C98.0314 40.4302 96.5299 41.8204 94.7925 41.8204ZM82.24 32.8928C79.0669 32.8928 76.487 35.2288 76.487 38.4519C76.487 41.6488 79.0669 44.0094 82.24 44.0094C85.4114 44.0094 87.993 41.6488 87.993 38.4519C87.993 35.2288 85.4114 32.8928 82.24 32.8928ZM82.24 41.8204C80.5009 41.8204 79.0012 40.4302 79.0012 38.4519C79.0012 36.4475 80.5009 35.0818 82.24 35.0818C83.9774 35.0818 85.4721 36.4475 85.4721 38.4519C85.4721 40.4302 83.9774 41.8204 82.24 41.8204ZM67.303 34.5966V36.9588H73.1217C72.9515 38.2787 72.4966 39.2491 71.7989 39.9254C70.9496 40.7422 69.6268 41.6488 67.303 41.6488C63.7221 41.6488 60.918 38.8472 60.918 35.3758C60.918 31.9045 63.7221 29.1029 67.303 29.1029C69.2392 29.1029 70.648 29.8363 71.6877 30.7871L73.4048 29.1225C71.9506 27.7764 70.016 26.7423 67.303 26.7423C62.3925 26.7423 58.2656 30.6156 58.2656 35.3758C58.2656 40.1361 62.3925 44.0094 67.303 44.0094C69.9571 44.0094 71.9506 43.1664 73.5177 41.5851C75.1237 40.0283 75.6242 37.8393 75.6242 36.0718C75.6242 35.5229 75.577 35.0181 75.4927 34.5966H67.303ZM128.382 36.4279C127.909 35.1847 126.448 32.8928 123.472 32.8928C120.523 32.8928 118.068 35.1455 118.068 38.4519C118.068 41.5655 120.498 44.0094 123.755 44.0094C126.389 44.0094 127.909 42.4526 128.534 41.5459L126.579 40.2832C125.927 41.2078 125.039 41.8204 123.755 41.8204C122.479 41.8204 121.564 41.2535 120.978 40.1361L128.647 37.0601L128.382 36.4279ZM120.563 38.2787C120.498 36.1355 122.28 35.0377 123.558 35.0377C124.559 35.0377 125.408 35.5229 125.691 36.2171L120.563 38.2787ZM114.33 43.6712H116.851V27.3353H114.33V43.6712ZM110.201 34.131H110.117C109.551 33.4809 108.471 32.8928 107.102 32.8928C104.231 32.8928 101.606 35.3366 101.606 38.4699C101.606 41.5851 104.231 44.0094 107.102 44.0094C108.471 44.0094 109.551 43.4164 110.117 42.7466H110.201V43.5438C110.201 45.6691 109.03 46.811 107.141 46.811C105.601 46.811 104.646 45.7328 104.251 44.8262L102.059 45.7132C102.691 47.1867 104.364 49 107.141 49C110.097 49 112.591 47.3141 112.591 43.2122V33.2309H110.201V34.131ZM107.318 41.8204C105.581 41.8204 104.126 40.4106 104.126 38.4699C104.126 36.5112 105.581 35.0818 107.318 35.0818C109.03 35.0818 110.38 36.5112 110.38 38.4699C110.38 40.4106 109.03 41.8204 107.318 41.8204ZM140.185 27.3353H134.156V43.6712H136.67V37.4815H140.185C142.977 37.4815 145.716 35.5229 145.716 32.4076C145.716 29.294 142.97 27.3353 140.185 27.3353ZM140.251 35.2092H136.67V29.6076H140.251C142.128 29.6076 143.2 31.1187 143.2 32.4076C143.2 33.672 142.128 35.2092 140.251 35.2092ZM155.793 32.8617C153.976 32.8617 152.087 33.6393 151.31 35.3628L153.541 36.2694C154.022 35.3628 154.905 35.0687 155.838 35.0687C157.142 35.0687 158.465 35.8283 158.485 37.1695V37.3411C158.03 37.0862 157.056 36.7089 155.858 36.7089C153.455 36.7089 151.007 37.9912 151.007 40.3844C151.007 42.5735 152.975 43.9832 155.188 43.9832C156.88 43.9832 157.813 43.2432 158.4 42.3823H158.485V43.6451H160.914V37.3786C160.914 34.4823 158.683 32.8617 155.793 32.8617ZM155.489 41.8138C154.667 41.8138 153.521 41.4185 153.521 40.4302C153.521 39.1658 154.95 38.6806 156.187 38.6806C157.294 38.6806 157.813 38.9175 158.485 39.2295C158.288 40.7422 156.945 41.8138 155.489 41.8138ZM169.761 33.2195L166.871 40.3011H166.785L163.797 33.2195H161.086L165.575 43.1158L163.013 48.6226H165.641L172.558 33.2195H169.761ZM147.097 43.6712H149.618V27.3353H147.097V43.6712Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 190,
    height: 61,
    rx: 3.5,
    stroke: "#585858"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1265_12979",
    x1: 35.446,
    y1: 45.3574,
    x2: 13.5241,
    y2: 22.7439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1265_12979",
    x1: 51.6704,
    y1: 30.6004,
    x2: 19.0504,
    y2: 30.6004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1265_12979",
    x1: 39.5269,
    y1: 27.6016,
    x2: 9.79906,
    y2: -3.06416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1265_12979",
    x1: 15.895,
    y1: 56.5102,
    x2: 29.1699,
    y2: 42.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.7917e3fa8da3ac592beb331530305981.svg";
export { ForwardRef as ReactComponent };